module.exports = __webpack_public_path__ + "img/checkbox-off.f1b5ad88.svg";